import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { ListGroup } from "@/ui";
import { MyTournamentRow } from "@/features/tournaments/MyTournamentRow";
import { useMyTournaments } from "@/features/queries";
import { PaginationBar } from "./PaginationBar";

const PER_PAGE = 20;

export function ProfileTournamentsPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const tournaments = useMyTournaments(PER_PAGE + 1, page * PER_PAGE);

  const items = (tournaments.data ?? []).slice(0, PER_PAGE);
  const hasNext = (tournaments.data ?? []).length > PER_PAGE;

  return (
    <div style={{ paddingBottom: 24 }}>
      <BackHeader title="Последние турниры" onBack={() => navigate("/profile")} />

      {tournaments.isLoading ? (
        <div className="body" style={{ padding: 16 }}>Загрузка…</div>
      ) : items.length === 0 ? (
        <div
          style={{
            background: "var(--bg-section)",
            borderRadius: "var(--r-lg)",
            margin: "0 16px",
            padding: 20,
            textAlign: "center",
            color: "var(--fg2)",
          }}
        >
          {page === 0 ? "Здесь появятся твои турниры." : "Больше турниров нет."}
        </div>
      ) : (
        <ListGroup>
          {items.map((t) => <MyTournamentRow key={t.id} tournament={t} />)}
        </ListGroup>
      )}

      <PaginationBar page={page} hasNext={hasNext} onPageChange={setPage} />
    </div>
  );
}

function BackHeader({ title, onBack }: { title: string; onBack: () => void }) {
  return (
    <div style={{ padding: "16px" }}>
      <button
        type="button"
        onClick={onBack}
        style={{
          background: "transparent",
          border: 0,
          color: "var(--fg2)",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: 0,
          marginBottom: 8,
          fontFamily: "var(--font-body)",
          fontSize: 13,
        }}
      >
        <ArrowLeft size={14} /> назад
      </button>
      <h1 className="h1" style={{ margin: 0 }}>{title}</h1>
    </div>
  );
}
